import * as React from 'react';
import { Image } from '@cian/ui-kit';

import { SuperAgentStar } from '../../../SuperAgent';

import * as styles from './styles.css';

interface IProps {
  size: number;
  url?: string | null;
  isSuperAgentStarShown?: boolean;
}

export const PhotoMobile = ({ size, url, isSuperAgentStarShown }: IProps) => {
  return (
    <div className={styles['image_wrp']}>
      <Image src={url || ''} width={size} height={size} borderRadius="50%" objectFit="cover" />
      {isSuperAgentStarShown && (
        <div className={styles['star']}>
          <SuperAgentStar underlay />
        </div>
      )}
    </div>
  );
};
